import DropdownMenuItemContainer from 'components/DropdownMenuItemContainer';
import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewEntityMenuItem: FunctionComponent<Props> = ({
    className = '',
    entityName,
    onClick,
    testId = TEST_ID
}) => (
    <DropdownMenuItemContainer className={className} onClick={onClick} testId={testId}>
        <BodyText className={styles.bodyText} text={entityName} />
    </DropdownMenuItemContainer>
);

export default DetailsViewEntityMenuItem;
